export const CREATE_MEAL = "CREATE_MEAL";
export const UPDATE_MEAL = "UPDATE_MEAL";
export const DELETE_MEAL = "DELETE_MEAL";
export const FETCH_MEALS = "FETCH_MEALS";
export const LISTEN_TO_SELECTED_MEAL = "LISTEN_TO_SELECTED_MEAL";
